'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dList$002dDirectives$002dPage from "./presto.-List-Directives-Page.js";
var $p;
/** @constructor */
function $c_Lpresto_ListDirectivesPage$() {
}
export { $c_Lpresto_ListDirectivesPage$ as $c_Lpresto_ListDirectivesPage$ };
$p = $c_Lpresto_ListDirectivesPage$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_ListDirectivesPage$;
/** @constructor */
function $h_Lpresto_ListDirectivesPage$() {
}
export { $h_Lpresto_ListDirectivesPage$ as $h_Lpresto_ListDirectivesPage$ };
$h_Lpresto_ListDirectivesPage$.prototype = $p;
$p.l = (function() {
  return "ListDirectivesPage";
});
$p.cG6 = (function(x$0) {
  return new $j_presto$002e$002dList$002dDirectives$002dPage.$c_Lpresto_ListDirectivesPage($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$uJ(x$0.j(0)), (!(!x$0.j(1))));
});
var $d_Lpresto_ListDirectivesPage$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_ListDirectivesPage$, "presto.ListDirectivesPage$", ({
  KG: 1,
  e: 1,
  g: 1
}));
export { $d_Lpresto_ListDirectivesPage$ as $d_Lpresto_ListDirectivesPage$ };
var $n_Lpresto_ListDirectivesPage$;
function $m_Lpresto_ListDirectivesPage$() {
  if ((!$n_Lpresto_ListDirectivesPage$)) {
    $n_Lpresto_ListDirectivesPage$ = new $c_Lpresto_ListDirectivesPage$();
  }
  return $n_Lpresto_ListDirectivesPage$;
}
export { $m_Lpresto_ListDirectivesPage$ as $m_Lpresto_ListDirectivesPage$ };
//# sourceMappingURL=presto.-List-Directives-Page$.js.map
